document.addEventListener("turbo:load", () => {
  document.querySelectorAll("input[data-css-preview=true]").forEach((element) => {
    element.addEventListener("change", (event) => {
      const updateRules = event.target.dataset.cssPreviewUpdates.split(";");
      updateRules.forEach((rule) => {
        const [target, property, value] = rule.split(":");
        if (target !== "") {
          document.querySelector(target).style[property.trim()] = value.trim();
        }
      });
    });
  });
});
